function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* initializeReactDatePicker import is needed
in order to properly map the react-with-styles based
component to support traditional classname mapping

https://github.com/airbnb/react-dates#initialize

In order to ensure that the initialize import is correctly
applied when the component is bundled at build time
we need to assign the default export to a named variable.
Otherwise, every consumer of the component
would need to manually import themselves.*/
//eslint-disable-next-line no-unused-vars
import initializeReactDatePicker from 'react-dates/initialize';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import _ from 'lodash';
import moment from 'js-utils/moment';
import DayPickerRangeController from 'react-dates/lib/components/DayPickerRangeController';
import Dropdown from '../../containers/dropdown/Dropdown';
import Icon from '../../icon/Icon';
import { datePropType, getAdditionalProps } from '../../utils/propTypes';
import { ISO_8601_DATE_FORMAT } from '../../utils/date';
import { START_DATE, END_DATE, localizedPhrases } from '../constants';
import ChevronLeftChunkySvg from '../../iconography/icons/ChevronLeftChunky';
import ChevronRightChunkySvg from '../../iconography/icons/ChevronRightChunky';
/*
react dates accepts only moment objects as date arguments and
asserts that if no value, `null` should be passed
 */

var _parseDateToMomentObject = function _parseDateToMomentObject(dateString) {
  return dateString ? moment(dateString) : null;
};
/* util to transform the returned moment object to our default date format string */


var _formatMomentObjectToISO = function _formatMomentObjectToISO(momentObj) {
  return momentObj && momentObj.format(ISO_8601_DATE_FORMAT);
};

var _convertDates = function _convertDates(startDate, endDate) {
  return {
    startDate: _formatMomentObjectToISO(startDate),
    endDate: _formatMomentObjectToISO(endDate)
  };
};

var RangePickerController =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RangePickerController, _PureComponent);

  function RangePickerController() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RangePickerController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RangePickerController)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_isOutsideRange", function (date) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      var isOutsideRange = minDate && date.isBefore(minDate) || maxDate && date.isAfter(maxDate);
      return isOutsideRange;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnDatesChange", function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;
      var onDatesChange = _this.props.onDatesChange;
      onDatesChange(_convertDates(startDate, endDate));
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnClose", function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose(_convertDates(startDate, endDate));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_getInitialMonth", function () {
      /* Initial rendered month should match
      that of the associated input's value */
      var _this$props2 = _this.props,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate,
          focusedInput = _this$props2.focusedInput;
      var momentObjToReturn = moment();

      if (startDate && focusedInput === START_DATE) {
        momentObjToReturn = moment(startDate);
      }

      if (endDate && focusedInput === END_DATE) {
        momentObjToReturn = moment(endDate);
      }

      return momentObjToReturn;
    });

    return _this;
  }

  _createClass(RangePickerController, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          daySize = _this$props3.daySize,
          weekDayFormat = _this$props3.weekDayFormat,
          navPrev = _this$props3.navPrev,
          navNext = _this$props3.navNext,
          transitionDuration = _this$props3.transitionDuration,
          hideKeyboardShortcutsPanel = _this$props3.hideKeyboardShortcutsPanel,
          numberOfMonths = _this$props3.numberOfMonths,
          minimumNights = _this$props3.minimumNights,
          phrases = _this$props3.phrases,
          focusedInput = _this$props3.focusedInput,
          onFocusChange = _this$props3.onFocusChange,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate,
          handleClickOutside = _this$props3.onClickOutside;

      if (!focusedInput) {
        return null;
      }

      var extraAttrs = getAdditionalProps(this);

      var formattedStartDate = _parseDateToMomentObject(startDate);

      var formattedEndDate = _parseDateToMomentObject(endDate);

      var translatedPhrases = _.mapValues(phrases, function (phrase) {
        if (typeof phrase === 'function') {
          return phrase;
        }

        return phrase.toString();
      });

      return React.createElement("div", {
        className: "eds-date-picker__controller"
      }, React.createElement(Dropdown, {
        onClickOutside: handleClickOutside,
        align: "left"
      }, React.createElement(DayPickerRangeController, _extends({}, extraAttrs, {
        onClose: this._handleOnClose,
        onDatesChange: this._handleOnDatesChange,
        isOutsideRange: this._isOutsideRange,
        initialVisibleMonth: this._getInitialMonth,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        focusedInput: focusedInput,
        onFocusChange: onFocusChange,
        daySize: daySize,
        weekDayFormat: weekDayFormat,
        navPrev: navPrev,
        navNext: navNext,
        transitionDuration: transitionDuration,
        hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
        numberOfMonths: numberOfMonths,
        minimumNights: minimumNights,
        phrases: translatedPhrases
      }))));
    }
  }]);

  return RangePickerController;
}(PureComponent);

_defineProperty(RangePickerController, "propTypes", {
  onDatesChange: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  startDate: datePropType,
  endDate: datePropType,
  minDate: datePropType,
  maxDate: datePropType,
  focusedInput: PropTypes.oneOf([START_DATE, END_DATE]),
  onFocusChange: PropTypes.func,
  onClickOutside: PropTypes.func,

  /* Configuration Options for react-dates/DayPickerRangeController defaulted below */

  /**
   * Pixel height and width of individual days
   */
  daySize: PropTypes.number,

  /**
   * Moment formatting string for how the week days should be displayed
   */
  weekDayFormat: PropTypes.string,

  /**
   * Button to navigate to previous month
   */
  navPrev: PropTypes.node,

  /**
   * Button to navigate to next month
   */
  navNext: PropTypes.node,

  /**
   * Transition duration for changing month animation
   */
  transitionDuration: PropTypes.number,

  /**
   * Bool to hide the keyboard shortcuts info panel
   */
  hideKeyboardShortcutsPanel: PropTypes.bool,

  /**
   * Number of months that should be displayed at one time
   */
  numberOfMonths: PropTypes.number,

  /**
   * Minimum selectable range size
   */
  minimumNights: PropTypes.number,

  /**
   * Informational aria-labels applied to the days within the calendar
   */
  phrases: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, EBPropTypes.translation, PropTypes.func]))
});

_defineProperty(RangePickerController, "defaultProps", {
  focusedInput: null,
  startDate: null,
  endDate: null,

  /* Defaulted configuration options for react-dates/DayPickerRangeController */

  /* A11y label configuration */
  phrases: localizedPhrases,

  /* Defaults for consistent calendar design appearance. Customize at own discretion */
  daySize: 42,
  weekDayFormat: 'dd',
  navPrev: React.createElement(Icon, {
    type: React.createElement(ChevronLeftChunkySvg, null),
    title: "previous"
  }),
  navNext: React.createElement(Icon, {
    type: React.createElement(ChevronRightChunkySvg, null),
    title: "next"
  }),
  transitionDuration: 0,
  hideKeyboardShortcutsPanel: true,
  numberOfMonths: 1,
  minimumNights: 0
});

export { RangePickerController as default };